import { logger } from 'shared/infrastructure/logger';

type ViewerLocation = {
  pathname: string;
  state?: { from?: string } | null;
};

/**
 * Avisa a Sentry de un error del visor. No recibe el usuario: el guid ya lo pone InitsContainer (DEU-286).
 * Sin `document.referrer` ni la query de la URL: pueden traer el token del login (security.md, regla 3).
 *
 * @param extra - Lo que manda el visor al fallar.
 */
export function logViewerError(isStudent: boolean, location: ViewerLocation, extra?: Record<string, unknown>): void {
  logger.warn('Viewer error', {
    tags: { page: 'viewer', isStudent },
    extra: {
      ...extra,
      currentPath: location.pathname,
      previousPath: location.state?.from,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    },
  });
}
